export const CLIENT_ERROR_MESSAGES = {
  REQUIRED: 'To pole jest wymagane',
  DEFAULT_ERROR: 'Wystąpił błąd. Spróbuj ponownie.',
  UNEXPECTED_ERROR: 'Nieoczekiwany błąd. Spróbuj ponownie.',
  EMAIL_ALREADY_EXISTS: 'Ten adres e-mail jest już zarejestrowany',
  NETWORK_ERROR: 'Błąd sieci. Sprawdź połączenie i spróbuj ponownie.',
  ZIP_INVALID_FORMAT: 'Nieprawidłowy format kodu pocztowego.',
  NIP_INVALID: 'Nieprawidłowy NIP',
  REGON_INVALID: 'Nieprawidłowy REGON',
  KRS_INVALID: 'Nieprawidłowy KRS',
  NO_PERMISSION_TOOLTIP: 'Nie masz uprawnień do wykonania tej czynności',
} as const;
